import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function Hero() {
  return <section className="pt-24 pb-16 md:pt-32 md:pb-24 bg-gradient-to-r from-blue-50 to-indigo-50" data-id="element-87">
      <div className="container mx-auto px-4" data-id="element-88">
        <div className="flex flex-col md:flex-row items-center" data-id="element-89">
          <div className="md:w-1/2 md:pr-12 mb-8 md:mb-0" data-id="element-90">
            <div className="inline-block px-4 py-2 rounded-full bg-blue-100 text-blue-800 font-medium text-sm mb-6" data-id="element-91">
              Exclusive Offer: $50 OFF with code "Super Neil"
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-92">
              Get Your ITIN Fast Online
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-93">
              The simple solution for foreign entrepreneurs to legally do
              business in the United States.
            </p>
            <div className="mb-8 space-y-3" data-id="element-94">
              <div className="flex items-center" data-id="element-95">
                <CheckCircleIcon className="text-green-500 mr-2" size={20} data-id="element-96" />
                <span className="text-gray-700" data-id="element-97">
                  IRS-certified acceptance agents
                </span>
              </div>
              <div className="flex items-center" data-id="element-98">
                <CheckCircleIcon className="text-green-500 mr-2" size={20} data-id="element-99" />
                <span className="text-gray-700" data-id="element-100">
                  No need to send original documents
                </span>
              </div>
              <div className="flex items-center" data-id="element-101">
                <CheckCircleIcon className="text-green-500 mr-2" size={20} data-id="element-102" />
                <span className="text-gray-700" data-id="element-103">Fast processing time</span>
              </div>
              <div className="flex items-center" data-id="element-104">
                <CheckCircleIcon className="text-green-500 mr-2" size={20} data-id="element-105" />
                <span className="text-gray-700" data-id="element-106">
                  Open US Bank Accounts & Credit Cards
                </span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-107">
              <a href="#pricing" className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-md font-medium text-center transition-colors" data-id="element-108">
                Apply Now & Save $50
              </a>
              <a href="#process" className="bg-white hover:bg-gray-100 text-blue-600 border border-blue-600 px-8 py-3 rounded-md font-medium text-center transition-colors" data-id="element-109">
                Learn How It Works
              </a>
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}